import React from 'react';

import Modal from 'Components/Modal';

export default function MsgModal({ header = null, msg = null, close }) {
  return (
    <Modal
      close={close}
      width="40%"
    >
      <div className="flex-row-v no-padding">
        <div className="cell-v cell-auto-v no-padding" style={{ textAlign: 'center' }}>
          <h2>
            {header}
          </h2>
        </div>
        <div className="cell-v cell-expand-v no-padding">
          <p style={{ whiteSpace: 'pre-wrap', backgroundColor: '#333333', padding: '10px' }}>
            {msg}
          </p>
        </div>
      </div>

    </Modal>
  );
}
